// migrated 1:1 from @nexato/nx-core-module, #688
import { InjectionToken, InputSignal, TemplateRef, Type } from "@angular/core";
import { IssueStatusChangedComponent } from "./issue-status-changed-activity-component";
import { IssueClosedComponent } from "./issue-closed-activity-component";
import { IssueReopenedComponent } from "./issue-reopened-activity-component";
import { Activity } from "../../../entities/activity/activity";
import { IssueCreatedComponent } from "./issue-created-activity-component";
import { IssueTitleUpdatedComponent } from "./issue-title-updated-activity-component";
import { IssueDescriptionUpdatedComponent } from "./issue-description-updated-activity-component";
import { NoteCreatedComponent } from "./note-created-activity-component";
import { LabelsUpdatedComponent } from "./labels-updated-activity-component";
import { IssueAssignedComponent } from "./issue-assigned-activity-component";
import { IssueDueDateTimeSetComponent } from "./issue-dueDateTime-set-activity-component";
import { EntityLinksUpdatedComponent } from "./entity-links-updated-component";
import { FilesUpdatedActivityComponent } from "./files-updated-activity-component";
import { IssueLocationUpdatedComponent } from "./issue-location-updated-activity-component";


export function createActivityComponentRegistry(): Map<string, Type<ActivityComponent>> {
  return new Map<string, Type<ActivityComponent>>([
    ['ISSUE_STATUS_CHANGED', IssueStatusChangedComponent],
    ['ISSUE_CLOSED', IssueClosedComponent],
    ['ISSUE_REOPENED', IssueReopenedComponent],
    ['ISSUE_CREATED', IssueCreatedComponent],
    ['ISSUE_TITLE_UPDATED', IssueTitleUpdatedComponent],
    ['ISSUE_DESCRIPTION_UPDATED', IssueDescriptionUpdatedComponent],
    ['ISSUE_LOCATION_UPDATED', IssueLocationUpdatedComponent],
    ['NOTE_CREATED', NoteCreatedComponent],
    ['LABELS_UPDATED', LabelsUpdatedComponent],
    ['ISSUE_ASSIGNED', IssueAssignedComponent],
    ['ISSUE_DUE_DATETIME_SET', IssueDueDateTimeSetComponent],
    ['ENTITY_LINKS_UPDATED', EntityLinksUpdatedComponent],
    ['FILES_UPDATED', FilesUpdatedActivityComponent],
    // ... weitere Mappings hier
  ]);
}

// Optional: Export der Components für einfacheres Hinzufügen
export const ACTIVITY_COMPONENT_LIST = [
  IssueStatusChangedComponent,
  IssueClosedComponent,
  IssueReopenedComponent,
  IssueCreatedComponent,
  IssueTitleUpdatedComponent,
  IssueDescriptionUpdatedComponent,
  NoteCreatedComponent,
  LabelsUpdatedComponent,
  IssueAssignedComponent,
  IssueDueDateTimeSetComponent,
  EntityLinksUpdatedComponent,
  FilesUpdatedActivityComponent,
  IssueLocationUpdatedComponent
];

export interface ActivityComponent {
  activity: InputSignal<Activity>;
  ownerId?: InputSignal<string | undefined>;
  getIndicatorTemplate?(): TemplateRef<unknown>;
}

export const ACTIVITY_COMPONENTS = new InjectionToken<Map<string, Type<ActivityComponent>>>('ACTIVITY_COMPONENTS');
